import React, { useState, useContext, useEffect } from 'react';

import { ButtonTitle, Button, RecordDeleteBtn } from '../../styles/commonStyles';
import CustomCheckBox from './CustomCheckBox';

import { LayoutContext } from '../../context/layoutContext';
import { FiTrash2 } from 'react-icons/fi';

import LinkBtn from './LinkBtn';
import FilterTabs from './FilterTabs';
import OnAirSchedule from './OnAirSchedule';
import SearchTabs from './SearchTabs';
import FlikingArrow from './FlikingArrow';
import Pagination from './Pagination';
import CloseBtn from './CloseBtn';

const TitleToOption = props => {
  const { matchese } = useContext(LayoutContext);
  const {
    className,
    title,

    titleOnclick,
    contentLength,
    optionType,
    optionValue,
    rtSearchValue,
    rtOptionClick,
    write,
    recordDelete,
    goPage,
    filterRtValue,
    checkBoxRtValue,
    point,
    fontSize,
    hide,
    order,
    titleStyle,
    titleColor,
    preArrow,
    nextArrow,
    pagination,
    paginationSelect,

    searchOptionCtHide,
    searchOptionDtHide,
    searchOptionEpNoOpen,
  } = props;

  const [option, setOption] = useState('');

  useEffect(() => {
    setOption(optionType);
  }, [optionType]);

  const optionRender = () => {
    let result;
    if (option === 'link') {
      result = <LinkBtn goPage={goPage} />;
    } else if (option === 'link-title') {
      result = <LinkBtn goPage={goPage} title={title} />;
    } else if (option === 'filter') {
      result = <FilterTabs rtValue={filterRtValue} />;
    } else if (option === 'onair') {
      result = <>{!matchese && <OnAirSchedule />}</>;
    } else if (option === 'checkBox') {
      result = <CustomCheckBox onClick={checkBoxRtValue} value={optionValue} />;
    } else if (option === 'search') {
      result = (
        <SearchTabs
          rtSearchValue={rtSearchValue}
          opContentsHide={searchOptionCtHide}
          opDateHide={searchOptionDtHide}
          searchOptionEpNoOpen={searchOptionEpNoOpen}
        />
      );
    } else if (option === 'search-write') {
      result = (
        <SearchTabs rtSearchValue={rtSearchValue} opContentsHide={searchOptionCtHide} opDateHide={searchOptionDtHide} write={write} />
      );
    } else if (option === 'fliking') {
      result = <FlikingArrow preArrow={preArrow} nextArrow={nextArrow} />;
    } else if (option === 'close') {
      result = <CloseBtn onClick={rtOptionClick} />;
    } else if (option === 'pagination') {
      result = <Pagination pagination={pagination} paginationSelect={paginationSelect} />;
    }

    return result;
  };

  return (
    <>
      {!hide && (
        <div
          className={className}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            position: 'relative',
            padding: '0px 1%',
            marginBottom: '5px',
            alignItems: 'center',
            flexWrap: matchese ? 'wrap' : 'nowrap',
            order: order,
          }}
        >
          <ButtonTitle point={point} fontSize={fontSize} style={titleStyle} titleColor={titleColor} onClick={titleOnclick} flex='1'>
            <span className='title'>{title ? title : ''}</span>
            <span>{contentLength ? `(${contentLength > 999 ? 1000 : contentLength})` : ``}</span>
          </ButtonTitle>

          {recordDelete && (
            <RecordDeleteBtn>
              <FiTrash2 />
              <Button onClick={recordDelete}>시청 기록 지우기</Button>
            </RecordDeleteBtn>
          )}

          {optionRender()}
        </div>
      )}
    </>
  );
};

export default TitleToOption;
